import React from 'react';
import './AdvancedSearchForm.less';
import { Form } from '@ant-design/compatible';
import { Input, Button, Select } from 'antd';
import 'moment/locale/da';
import moment from 'moment';
moment.locale('da');

const FormItem = Form.Item;

class AdvancedSearchForm extends React.Component {
  /**
   * Validates & submits data to backend
   * @param e is the submit button.
   */
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.opslag([values]);
      }
    });
  };

  /**
   * returns the list of the returned values from dawa
   * @returns {*}
   */
  handleAddressSuggestions = () => {
    return this.props.addressSuggestions.toJS().map((address) => {
      return (
        <Select.Option key={address.tekst} value={address.adresse.id}>
          {address.tekst}
        </Select.Option>
      );
    });
  };

  validateIfCompanyOrPerson = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  };

  /**
   * Looks up in dawa to create address auto completion.
   * @returns {*}
   */
  handleSearch = (value) => {
    this.props.dawaLookup(value);
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8, textAlign: 'left' },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 8 },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem {...formItemLayout} label={'Fornavn'}>
          {getFieldDecorator('firstName', {
            rules: [
              {
                required: false,
                message: 'Fornavn skal udfyldes.',
                whitespace: false,
              },
            ],
          })(<Input />)}
        </FormItem>
        <FormItem {...formItemLayout} label={'Efternavn/Virksomhed'}>
          {getFieldDecorator('lastName', {
            rules: [
              {
                required: true,
                message: 'Efternavn/Virksomhed skal udfyldes.',
                whitespace: true,
              },
            ],
          })(<Input />)}
        </FormItem>
        <FormItem {...formItemLayout} label={'Adresse'}>
          {getFieldDecorator('addressId', {
            rules: [
              {
                required: true,
                message: 'Adresse skal udfyldes',
                whitespace: true,
              },
            ],
          })(
            <Select showSearch={true} onSearch={this.handleSearch} optionFilterProp={'children'}>
              {this.handleAddressSuggestions()}
            </Select>
          )}
        </FormItem>
        <FormItem {...formItemLayout} label={'Fødselsdato'}>
          {getFieldDecorator('birthday', {})(<Input placeholder={'DDMMYY'} />)}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type={'primary'} htmlType={'submit'} className={'float-right'}>
            Søg
          </Button>
        </FormItem>
      </Form>
    );
  }
}

export default Form.create()(AdvancedSearchForm);
